export default __webpack_public_path__ + "static/37-03ac96f6787c9e802ac7401a45d84243.jpg";